import script from "./AppMiniCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMiniCard.vue?vue&type=script&setup=true&lang=js"

import "./AppMiniCard.vue?vue&type=style&index=0&id=23ca9913&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ca9913"]])

export default __exports__